import { Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import moment from "moment";
import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { setFormulaFilteredData } from "store/app/report-management/reports/actions";
import {
    DATA_TYPE_OPTIONS,
    FORMULA_USAGE_FIELD_OPTIONS,
    METRICS_OPTIONS,
    METRICS_OPTIONS_YESNO
} from "store/app/report-management/reports/constants";
import { getRoleOptions } from "store/app/user-management/actions";

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterReports = (props) => {

    const { open, onClose, formulaFilterData } = props;

    const [isAutoOpenDataType, setIsAutoOpenDataType] = useState();
    const [isAutoOpenMetrics, setIsAutoOpenMetrics] = useState();
    const [isFormulaUsedFormFields, setIsFormulaUsedFormFields] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (formulaFilterData) {
            setFilter(formulaFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }

    const handleSelect = (e, option, name) => {
        const { label, value } = option || {};
        if (name === "datatype") {
            setFilter({
                ...filter,
                [name]: value,
                metrics: null,
            });
        }
        else {
            setFilter({
                ...filter,
                [name]: label,
            });
        }

    }

    const validateOnDate = (date) => {
        const formattedDate = date ? moment(date).format("DD-MM-YYYY") : null;
        setFilter({
            ...filter,
            createdon: formattedDate,
        });
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setFormulaFilteredData(nonEmptyData);
    }
    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setFormulaFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'xs'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    autoFocus
                                                    label="Formula Name"
                                                    fullWidth
                                                    size="small"
                                                    name='reportname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.reportname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={DATA_TYPE_OPTIONS}
                                                    open={isAutoOpenDataType}
                                                    onOpen={() => setIsAutoOpenDataType(true)}
                                                    onClose={() => setIsAutoOpenDataType(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'datatype')}
                                                    value={filter?.datatype ? DATA_TYPE_OPTIONS?.find((dt) => dt.value === filter?.datatype) : ""}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Data Type"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={filter?.datatype === "Yes/No" ? METRICS_OPTIONS_YESNO : METRICS_OPTIONS}
                                                    open={isAutoOpenMetrics}
                                                    onOpen={() => setIsAutoOpenMetrics(true)}
                                                    onClose={() => setIsAutoOpenMetrics(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'metrics')}
                                                    value={filter?.metrics || ""}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Metrics"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={FORMULA_USAGE_FIELD_OPTIONS}
                                                    open={isFormulaUsedFormFields}
                                                    onOpen={() => setIsFormulaUsedFormFields(true)}
                                                    onClose={() => setIsFormulaUsedFormFields(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'isusedinformfield')}
                                                    value={filter?.isusedinformfield}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Is Used In Form Field ?"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="Created By"
                                                    fullWidth
                                                    size="small"
                                                    name='createdby'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.createdby}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="Created On"
                                                        onChange={validateOnDate}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.createdon ? moment.utc(filter.createdon, "DD-MM-YYYY") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    formulaFilterData: state.formulae.formulaFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setFormulaFilteredData: (filter) => dispatch(setFormulaFilteredData(filter)),
    getRoleOptions: () => dispatch(getRoleOptions()),

})

export default connect(mapStateToProps, mapDispatchToProps)(FilterReports);